export default __webpack_public_path__ + "fe1e732.png";